import React from 'react';
import cn from 'classnames';
import styles from './TabNavigation.module.scss';
import KeyboardShortcut from '@components/KeyboardShortcut';
import { useHotkeyHandler } from '@support/hooks/use-hotkey-handler';

interface Tab {
  index: number;
  title: string;
  shortcut?: string;
}

export default function TabNavigation({
  tabs,
  activeTabIdx,
  setActiveTabIdx,
  children,
}: {
  tabs: Tab[];
  activeTabIdx: number;
  setActiveTabIdx: (tab: number) => void;
  children?: React.ReactNode;
}) {
  useHotkeyHandler(
    {
      handler: (e) => {
        if (e.defaultPrevented) {
          return;
        }

        const keyAsIdx = (parseInt(e.key) || 0) - 1;

        if (!!tabs[keyAsIdx] && keyAsIdx !== activeTabIdx) {
          e.preventDefault();
          setActiveTabIdx(keyAsIdx);
          return;
        }
      },
    },
    [tabs, activeTabIdx],
  );

  return (
    <div className={styles.tabs}>
      {tabs.map(({ title, index }) => (
        <KeyboardShortcut
          key={index}
          placement="bottom"
          shortcut={<KeyboardShortcut.Key>{index + 1}</KeyboardShortcut.Key>}
        >
          <div className={cn(styles.tab, index === activeTabIdx && styles.tabActive)}>
            <button
              className={cn(styles.tabButton, 'btn-none')}
              onClick={(e) => {
                e.preventDefault();
                setActiveTabIdx(index);
              }}
            >
              {title}
            </button>
          </div>
        </KeyboardShortcut>
      ))}
      {children && <div className={styles.tabMenuContent}>{children}</div>}
    </div>
  );
}
